import React from 'react';
import '../CSS/Healthcare.css';

const healthcareLogos = [
  { src: '/assets/Web Version/Who We Serve/Healthcare/auburn-univ-logo.png', alt: 'Auburn University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/utahstate-univ-logo.png', alt: 'Utah State University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/purdue-univ-logo.png', alt: 'Purdue University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/pennstate-univ-logo.png', alt: 'Penn State University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/texas-univ-logo.png', alt: 'Texas A&M University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/montefiore-univ-logo.png', alt: 'Montefiore Einstein' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/mississppi-univ-logo.png', alt: 'University of Mississippi Grenada' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/mtsuv-univ-logo.png', alt: 'Middle Tennessee State University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/georgia-univ-logo.png', alt: 'University of Georgia' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/idaho-univ-logo.png', alt: 'Idaho State University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/fgcu-univ-logo.png', alt: 'Florida Gulf Coast University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/gannon-univ-logo.png', alt: 'Gannon University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/wake-forest-univ-logo.png', alt: 'Wake Forest University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/university-of-texas-logo.png', alt: 'University of Texas at El Paso' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/umass-univ-logo.png', alt: 'UMass Dartmouth' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/methodist-univ-logo.png', alt: 'Methodist University' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/the-citadel-univ-logo.png', alt: 'The Citadel' },
  { src: '/assets/Web Version/Who We Serve/Healthcare/mississippi-college-logo.png', alt: 'Mississippi College' },
];

const Healthcare: React.FC = () => {
  return (
    <div className="healthcare-page">
      <div className="healthcare-hero-banner">
        <div className="healthcare-hero-content">
          <p className="healthcare-breadcrumb">Who We Serve / Healthcare</p>
          <h1 className="healthcare-title">Healthcare</h1>
        </div>
      </div>

      <div className="healthcare-body">
        <div className="healthcare-intro">
          <p>
            Myers McRae collaborates with hospitals, medical universities, and health systems to recruit
            leaders who drive innovation and improve patient outcomes. Leveraging AI-enabled analytics and
            human expertise, we identify talent that aligns with the evolving needs of modern health care.
            Our strategic approach ensures that every placement strengthens both clinical excellence and
            organizational performance. From academic medical centers to specialized care providers, our
            clients embody compassion, integrity, and progress. We are honored to showcase these exceptional
            health care partners who have placed their trust in Myers McRae.
          </p>
        </div>

        <div className="healthcare-icons">
          {healthcareLogos.map((logo) => (
            <div key={logo.alt} className="healthcare-icon-cell">
              <img src={logo.src} alt={logo.alt} className="healthcare-icon" />
            </div>
          ))}
        </div>

        {/* <div className="healthcare-icon-text">
          <p>and many more...</p>
        </div> */}
      </div>
    </div>
  );
};

export default Healthcare;

